export const whoseQRCode = ["Elearning IEU"];

export const typeOfDocumentQRCode = [
  { label: "Official Statement IEU", value: "basic-word" },
  { label: "Basic PDF", value: "basic-pdf" },
];

export const selectEmail = ["developer@ieu.edu.ua", "elearning@ieu.edu.ua"];

export const coverLetter = [
  {
    label: "Without text",
    value: "",
  },
  {
    label: "Cover letter text for transcript",
    value: `
      <p>Dear Student,</p>
      <p>&nbsp;</p>
      <p>Warm greetings from International European University.</p>
      <p>
        We are pleased to inform you that your academic transcript has been
        successfully processed. Please find the official document attached
        to this email for your reference and records.
      </p>
      <p>
        Should you require any further assistance or have any questions
        regarding your transcript or academic status, please do not hesitate
        to contact us. We are always here to support you.
      </p>
      <p>&nbsp;</p>
      <p>Wishing you continued success in your academic journey!</p>
      <p>&nbsp;</p>
      <p>Kind regards,</p>
    `,
  },
];
